/*
 * Copyright (c) 2020. American Express Company
 */

import { DialogTemplateModel } from './dialog-template.model';
import { InterfaceActionTypeModel } from './interface-action-type.model';

export class UserActionTypeModel {
    id!: number;
    name: string;
    description?: string;
    slug: string;
    nextTemplate?: DialogTemplateModel;
    interfaceActionTypes: InterfaceActionTypeModel[];
    primary: boolean;
}
